import { LocationStrategy } from '@angular/common';
import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Directive({
  selector: '[appRouterLink]',
  exportAs: 'appRouterLink',
  standalone: true,
})
export class AppRouterLinkDirective extends RouterLink implements OnChanges {
  readonly #router!: Router;

  readonly #renderer!: Renderer2;

  readonly #el!: ElementRef;

  readonly #locationStrategy?: LocationStrategy;

  constructor(
    router: Router,
    route: ActivatedRoute,
    renderer: Renderer2,
    el: ElementRef,
    locationStrategy?: LocationStrategy,
  ) {
    super(router, route, '0', renderer, el, locationStrategy);

    this.#router = router;
    this.#renderer = renderer;
    this.#el = el;
    this.#locationStrategy = locationStrategy;
  }

  @Input()
  set appRouterLink(commands: Array<unknown> | string | null | undefined) {
    this.routerLink = commands;
  }

  @Input({ required: false })
  override set routerLink(
    commands: Array<unknown> | string | null | undefined,
  ) {
    super.routerLink = commands;
  }

  override ngOnChanges(changes: SimpleChanges) {
    this.#setHrefAttribute();

    super.ngOnChanges(changes);
  }

  @HostListener('click', [
    '$event.button',
    '$event.ctrlKey',
    '$event.shiftKey',
    '$event.altKey',
    '$event.metaKey',
    '$event',
  ])
  override onClick(
    button: number,
    ctrlKey: boolean,
    shiftKey: boolean,
    altKey: boolean,
    metaKey: boolean,
    event?: Event,
  ): boolean {
    if (this.#el.nativeElement.disabled) {
      return false;
    }

    event?.preventDefault();

    return super.onClick(button, ctrlKey, shiftKey, altKey, metaKey);
  }

  #setHrefAttribute() {
    const { urlTree } = this;
    const href =
      urlTree !== null && this.#locationStrategy
        ? this.#locationStrategy?.prepareExternalUrl(
            this.#router.serializeUrl(urlTree),
          )
        : null;

    this.#applyAttributeValue('href', href);
  }

  #applyAttributeValue(attrName: string, attrValue: string | null) {
    const renderer = this.#renderer;
    const { nativeElement } = this.#el;

    if (attrValue !== null) {
      renderer.setAttribute(nativeElement, attrName, attrValue);
    } else {
      renderer.removeAttribute(nativeElement, attrName);
    }
  }
}
